import { Flex, Progress, Skeleton, Text } from '@mantine/core';
import { Card } from '../../../../../../component';
import { observer } from 'mobx-react';
import { useContestStore } from '../../../../../../store';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Routes } from '../../../../../../route/Routes';
import { ObtainablePoints } from '../../../../../../component/ObtainablePoints';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from '../../../../../../hooks';
import { inAppNavigation } from '../../../../../../hooks';

export const LoyalityPointInfo = observer(() => {
  const contestStore = useContestStore();
  const navigate = useNavigate();
  const { funds, currentRank, rankPointLimit } = contestStore;
  const progress = (funds / (rankPointLimit ?? 1)) * 100;
  const { t } = useTranslation('homescreen');
  const isSmallScreen = useWindowSize(1100);

  useEffect(() => {
    contestStore.loadFunds();
  }, [contestStore]);

  return (
    <div
      onClick={() => navigate(Routes.Points, inAppNavigation)}
      style={{ cursor: 'pointer', height: '100%' }}
    >
      <Card
        size="small"
        flexProps={{ wrap: 'wrap' }}
        style={{ height: '100%' }}
      >
        <Skeleton visible={!currentRank} h="100%">
          <Flex
            gap="16px"
            justify="space-between"
            wrap="wrap"
            h="100%"
            w="100%"
            flex="1"
            direction={isSmallScreen ? 'column' : 'row'}
          >
            <Flex
              wrap="wrap"
              direction={isSmallScreen ? 'column' : 'row'}
              gap={isSmallScreen ? '0px' : '4px'}
              flex="1"
            >
              <Text fw="700">{t('Level')}</Text>
              <Text>{t('TierList.' + currentRank)}</Text>
            </Flex>

            <Flex gap="10px" align="center" wrap="wrap" flex="1">
              <Progress
                value={progress}
                flex="1"
                miw="70px"
                c="#1570CB"
                styles={(theme) => ({
                  section: {
                    backgroundColor: theme.colors.blue[6],
                  },
                  root: {
                    backgroundColor: '#B1B1B1',
                  },
                })}
              />

              <div>
                <ObtainablePoints
                  points={rankPointLimit ? funds + '/' + rankPointLimit : funds}
                  direction="row-reverse"
                  showPlus={false}
                />
              </div>
            </Flex>
          </Flex>
        </Skeleton>
      </Card>
    </div>
  );
});
